export const MAX_TOTAL_MEDIA = 4;
export const MAX_VIDEOS = 1;

export const MAX_IMAGE_INPUT_MB = 20;
export const MAX_IMAGE_INPUT_BYTES = MAX_IMAGE_INPUT_MB * 1024 * 1024;

export const MAX_VIDEO_SIZE_MB = 50;
export const MAX_VIDEO_SIZE_BYTES = MAX_VIDEO_SIZE_MB * 1024 * 1024;

export const IMAGE_TARGET_LONGEST_EDGE = 1920;
export const IMAGE_TARGET_QUALITY = 0.85;
export const IMAGE_COMPRESS_SKIP_MAX_BYTES = 512_000;
